import { getAllModelListProvidences } from '../services/CatalogsService'
import { useState, useEffect } from 'react'
import TableContentProvidences from './TableContentProvidences'
import { useSearch } from '../context/KeywordSearchContext'


export default function Providences() {
    const [offset, setOffset] = useState(0)
	const [products, setProducts] = useState([])
	const[pageSize, setPageSize] = useState(0);
    const [, setIsLoading] = useState(true)
    const [, setMessage] = useState("")
	let token = localStorage.getItem("site");

	const {keyword} = useSearch()

	const handleChange = (event, value) => {
    	setOffset(value - 1)
    }

	const fetchData = async () => {
		try {
			const response = await getAllModelListProvidences(token, offset, 10, keyword)
			setProducts(response.data.content)
			setMessage(response.data.message)
			setPageSize(response.data.totalPages)
			setIsLoading(false)
		} catch (err) {
			setProducts([])
			setMessage()
		}
	}

	useEffect(()=>{
        fetchData()
    },[offset, keyword])	
	
	return (
		<TableContentProvidences offset={offset} handleChange={handleChange} pageSize={pageSize} products={products}
			fetchData={fetchData}/>
	) 
}